const layers = {
	activeFire: {
		label: "Active fires",
		value: "activeFire"
	},
	wildFireAi: {
		label: "Wildfire AI risk score",
		value: "wildFireAi"
	}
};

export default layers;
